"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const uuid_1 = __importDefault(require("uuid"));
const LayerFactory_1 = __importDefault(require("./LayerFactory"));
const MWaterContextComponent_1 = require("../MWaterContextComponent");
// Dropdown to add a new layer.
// Can be overridden by context of addLayerElementFactory which is called with all props
class AddLayerComponent extends react_1.default.Component {
    static contextType = MWaterContextComponent_1.AddLayerElementFactoryContext;
    handleAddLayer = (newLayer) => {
        const layerView = {
            id: (0, uuid_1.default)(),
            name: newLayer.name,
            desc: "",
            type: newLayer.type,
            visible: true,
            opacity: 1,
            design: null
        };
        // Clean design to make valid
        const layer = LayerFactory_1.default.createLayer(layerView.type);
        layerView.design = layer.cleanDesign(newLayer.design, this.props.schema);
        return this.handleAddLayerView(layerView);
    };
    handleAddLayerView = (layerView) => {
        // Add to list
        const layerViews = this.props.design.layerViews.slice();
        layerViews.push(layerView);
        const design = { ...this.props.design, layerViews };
        this.props.onDesignChange(design);
    };
    render() {
        if (this.context) {
            return this.context(this.props);
        }
        const newLayers = [
            {
                label: T `Marker Layer`,
                name: T `Untitled Layer`,
                type: "Markers",
                design: {}
            },
            {
                label: T `Radius (circles) Layer`,
                name: T `Untitled Layer`,
                type: "Buffer",
                design: {}
            },
            {
                label: T `Choropleth Layer`,
                name: T `Untitled Layer`,
                type: "AdminChoropleth",
                design: {}
            },
            {
                label: T `Cluster Layer`,
                name: T `Untitled Layer`,
                type: "Cluster",
                design: {}
            },
            {
                label: T `Grid Layer`,
                name: T `Untitled Layer`,
                type: "Grid",
                design: {}
            },
            {
                label: T `Custom Tile Url (advanced)`,
                name: T `Untitled Layer`,
                type: "TileUrl",
                design: {}
            }
        ];
        return R("div", { style: { margin: 5 }, key: "addLayer", className: "btn-group" }, R("button", { type: "button", "data-bs-toggle": "dropdown", className: "btn btn-primary dropdown-toggle" }, R("span", { className: "fas fa-plus" }), ` ${T `Add Layer`}`), R("ul", { className: "dropdown-menu" }, lodash_1.default.map(newLayers, (layer, i) => {
            return R("li", { key: "" + i }, R("a", { className: "dropdown-item", onClick: this.handleAddLayer.bind(null, layer) }, layer.label || layer.name));
        })));
    }
}
exports.default = AddLayerComponent;
